export const FOOD_SECTIONS = [
  {name: 'Basic'},
  {name: 'Menu'},
  {name: 'Cost'},
  {name: 'Tags'},
  {name: 'Additional'}
]
